"use client";

import { motion } from "framer-motion";
import {
  FaCode,
  FaSearch,
  FaMobileAlt,
  FaChartLine,
  FaServer,
  FaPalette,
} from "react-icons/fa";

const services = [
  {
    icon: <FaCode size={32} />,
    title: "Web Development",
    description:
      "Custom website design and development focused on high performance, responsive layouts, and engaging user experiences.",
    color: "#3b82f6",
  },
  {
    icon: <FaSearch size={32} />,
    title: "SEO Services",
    description:
      "Expert search engine optimization (SEO) strategies to increase website visibility, organic traffic, and keyword rankings.",
    color: "#3b82f6",
  },
  {
    icon: <FaMobileAlt size={32} />,
    title: "Mobile Apps",
    description:
      "Native and cross-platform mobile app development for iOS and Android, delivering seamless user experiences and robust features.",
    color: "#3b82f6",
  },
  {
    icon: <FaChartLine size={32} />,
    title: "Digital Marketing",
    description:
      "Comprehensive digital marketing services, including PPC, content marketing, social media strategies, and conversion optimization.",
    color: "#3b82f6",
  },
  {
    icon: <FaServer size={32} />,
    title: "Backend Solutions",
    description:
      "Secure, scalable backend development with RESTful APIs, custom databases, and cloud infrastructure for reliable performance.",
    color: "#3b82f6",
  },
  {
    icon: <FaPalette size={32} />,
    title: "UI/UX Design",
    description:
      "Creative UI/UX design services crafting beautiful interfaces with intuitive user flows to enhance customer engagement.",
    color: "#3b82f6",
  },
];

export default function Services() {
  return (
    <section id="services" className="services">
      <div className="services__container">
        <motion.h2
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="services__title"
        >
          <span>Our</span> Services
        </motion.h2>

        <motion.div
          className="services__grid"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
          variants={{
            visible: {
              transition: {
                staggerChildren: 0.1,
              },
            },
          }}
        >
          {services.map(({ title, description, icon, color }, i) => (
            <motion.div
              className="services__card"
              key={title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              whileHover={{ y: -5 }}
            >
              <div
                className="services__icon-wrapper"
                style={{
                  background: `linear-gradient(135deg, ${color}22, ${color}11)`,
                  color: color,
                }}
              >
                {icon}
              </div>
              <h3 className="services__card-title">{title}</h3>
              <p className="services__card-description">{description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
